export default __webpack_public_path__ + "e1f02f9160f5583d32f612f6e0e7befa.png";